export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9317.05bc671a.jpg";